<!--  -->
<template>
  <div :class="['scenelist',isMobile?'mlayout':'layout']">   
    <div class="inner" v-if="!isMobile">
      <div class="top-model">
        <div class="f1" v-if="curfloor=='F1'">
          <div class="model" id="f1"><img ref="f1" src="@/assets/images/F1.png" alt=""><span id="p1"
              class="item1"></span><span id="p2" class="item2"></span><span id="p3" class="item3"></span><span id="p4"
              class="item4"></span></div>
          <div class="list">
            <div :class="['item','item'+item.pic]" v-for="(item,index) in scenes.f1" :key="index" @click='goInScene(item.link)'><img class="gif" :id="'pic'+item.pic" :src="require('@/assets/images/f1/'+item.pic+'.gif')" alt="">
              <div class="intro"><span>{{item.name}}</span>
                <p>{{item.intro}}</p>
              </div>
            </div>
            
          </div>
        </div>
        <div class="f2" v-else>
          <div class="model" id="f2"><img ref="f2" src="@/assets/images/F2_new.png" alt=""><span id="p1"
              class="item1"></span><span id="p2" class="item2"></span><span id="p3" class="item3"></span><span id="p4"
              class="item4"></span></div>
          <div class="list">
            <div :class="['item','item'+item.pic]" v-for="(item,index) in scenes.f2" :key="index" @click='goInScene(item.link)'><img class="gif" :id="'pic'+item.pic" :src="require('@/assets/images/mobile/'+item.pic+'.gif')" alt="">
              <div class="intro"><span>{{item.name}}</span>
                <p>{{item.intro}}</p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
     <!--  <div class="drawing-container">
        <canvas id="linecanvas" width='1920' height='1000'></canvas>
      </div> -->


      <div class="bottom-nav">
        <span v-for="(item,i) in floors" :key="i"  :class="{'on' : item.floor==curfloor}" @click="goFloor(item)">{{item.floor}}</span>
        
      </div>
    </div>
    <Aside v-if="!isMobile"></Aside>
    <bar v-if="!isMobile"></bar>
    <div class="minner" v-else>
      <div class="mcontainer">
        <div class="title">
        场馆漫游
        </div>
        <div class="list">
          <div class="item" v-for="(item,i) in mlist" :key="i" @click='goInScene(item.link)'>
            <img :src="require('@/assets/images/mobile/'+item.pic+'.gif')" alt="">
            <span class="name">{{item.name}}</span>
            <p class="intro">{{item.intro}}</p>
          </div>
        </div>
        <div class="goback" @click="$router.go(-1)"><img src="@/assets/images/mobile/back.png" alt=""></div>
      </div>
      
    </div>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import browser from '@/utils/browser.js'
  import $ from 'jquery'
  import aside from '@/components/layout/aside.vue'
  import bar from '@/components/layout/bar.vue'
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
      'Aside': aside,
      bar
    },
    data() {
      //这里存放数据
      return {
        isMobile:browser.mobile,
        curfloor:'F1',
        mlist:[
          {
              name:'序厅',
              intro:'星星之火可以燎原',
              pic:'3',
              link:'815'
            },{
              name:'第一展厅',
              intro:'中国革命道路的艰难探索',
              pic:'2',
              link:'816'
            },{
              name:'第二展厅',
              intro:'井冈山革命根据地的创立',
              pic:'1',
              link:'826'
            },{
              name:'第三展厅',
              intro:'井冈山革命根据地的发展',
              pic:'4',
              link:'809'
            },{
              name:'第四展厅',
              intro:'井冈山革命根据地的新局面',
              pic:'7',
              link:'812'
            },{
              name:'第五展厅',
              intro:'走向全国胜利',
              pic:'6',
              link:'817'
            },
            // {
            //   name:'第六展厅',
            //   intro:'临时展厅',
            //   pic:'5',
            //   link:'811'
            // },
            {
              name:'沙盘',
              intro:'井冈山革命根据地沙盘模型',
              pic:'8',
              link:'814'
            }
        ],
        scenes:{
          f1:[
            {
              name:'第二展厅',
              intro:'井冈山革命根据地的创立',
              pic:'1',
              link:'826'
            },
            {
              name:'第一展厅',
              intro:'中国革命道路的艰难探索',
              pic:'2',
              link:'816'
            },
            {
              name:'序厅',
              intro:'星星之火可以燎原',
              pic:'3',
              link:'815'
            },
            {
              name:'第三展厅',
              intro:'井冈山革命根据地的发展',
              pic:'4',
              link:'809'
            }
          ],
          f2:[
            // {
            //   name:'第六展厅',
            //   intro:'千里来寻故地',
            //   pic:'5',
            //   link:'811'
            // },
            {
              name:'第五展厅',
              intro:'走向全国胜利',
              pic:'6',
              link:'817'
            },
            {
              name:'第四展厅',
              intro:'井冈山革命根据地的新局面',
              pic:'7',
              link:'812'
            },
            {
              name:'沙盘',
              intro:'井冈山革命根据地沙盘模型',
              pic:'8',
              link:'814'
            }
          ]
        },
        floors:[
          {
            floor:'F1'
          },
          {
            floor:'F2'
          }
        ],
        /* Coords: {
          p1: {
            name: '第二展厅',
            sx: 0,
            sy: 0,
            ex: 0,
            ey: 0,
            startId: '#pic1'
          },
          p2: {
            name: '第一展厅',
            sx: 0,
            sy: 0,
            ex: 0,
            ey: 0,
            startId: '#pic2'
          },
          p3: {
            name: '序厅',
            sx: 0,
            sy: 0,
            ex: 0,
            ey: 0,
            startId: '#pic3'
          },
          p4: {
            name: '第三展厅',
            sx: 0,
            sy: 0,
            ex: 0,
            ey: 0,
            startId: '#pic4'
          }
        } */
      }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      goInScene(link) {
        this.$router.push({path:'/scene/',query:{link:link}})
      },
      goFloor(item) {
        this.curfloor=item.floor
      },
      animationline() {
        var that = this;
        var canvas = document.getElementById("linecanvas");
        var ctx = canvas.getContext("2d");

        /*
        	canvas 元素的自适应大小与重新绘制
        	-------------------------------------------------------------------------------------
        */
        function canvasResize() {
          canvas.width = $(".drawing-container").width();
          canvas.height = $(".drawing-container").height();
        }

        canvasResize();

        $(window).resize(function () {
          canvasResize();
        });

        //绘制任意两点之间的动态直线

        /*
        	画动态直线
        	@(x1,y1)    起点
        	@(x2,y2)    终点
        */
        function drawDot(x1, y1, x2, y2, s) {

          if (s !== 10) {
            ctx.arc(x1, y1, s, 0, 2 * Math.PI);
            ctx.fill();
            ctx.stroke();
            s++;
            requestAnimationFrame(function () {
              drawDot(x1, y1, x2, y2, s);
            });
          } else {

            if (x1 == x2) {
              drawVerticalLine(x1, y1, x2, y2); /*斜率不存在的情况*/
            } else {
              drawCommonLine(x1, y1, x2, y2); /*斜率为正或者负或者0*/
            }
          }
          /*k存在的情况*/
          function drawCommonLine(x1, y1, x2, y2) {

            //y=kx+b
            var k = (y2 - y1) / (x2 - x1) //斜率k     正 负 0
            var b = y1 - k * x1 //常数b
            var i = 0;
            var flag = compare(x1, x2);

            function draw() {
              var xi = x1 + i;
              var yi = k * xi + b;
              var xj = x1 + i + 5 //控制步长决定绘制的是虚线还是实线
              var yj = k * xj + b;
              drawLine(xi, yi, xj, yj);
              i += flag;
              if (Math.abs(i) <= Math.abs(x1 - x2)) {
                window.setTimeout(function () {
                  draw();
                }, 5);
              }
            }
            draw();
          }

          /*k不存在，也就是垂直的情况*/
          function drawVerticalLine(x1, y1, x2, y2) {
            var i = 0;
            var flag = compare(y1, y2);

            function draw() {
              var yi = y1 + i;
              var yj = y1 + i + 5 * flag;
              drawLine(x1, yi, x2, yj);
              i += flag;
              if (Math.abs(i) <= Math.abs(y1 - y2)) {
                window.setTimeout(function () {
                  draw();
                }, 5);
              }
            }
            draw();
          }

          /*比较函数*/
          function compare(a, b) {
            if (a < b) {
              return 1;
            } else {
              return -1;
            }
          }


          /*线条片段*/
          function drawLine(x1, y1, x2, y2) {
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.lineWidth = 2;
            ctx.strokeStyle = "#ff0000";
            ctx.stroke();
            ctx.closePath();
          }

          /*清除画布*/
          function clear() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
          }
        }

        function drawDynamicLine(x1, y1, x2, y2) {
          let size = 0;
          ctx.fillStyle = '#ff0000';
          ctx.strokeStyle = '#ff0000';
          ctx.beginPath();
          drawDot(x1, y1, x2, y2, size);
        }
        console.log("坐标", that.Coords)
        drawDynamicLine(that.Coords.p1.sx, that.Coords.p1.sy, that.Coords.p1.ex, that.Coords.p1.ey);
         drawDynamicLine(that.Coords.p2.sx, that.Coords.p2.sy, that.Coords.p2.ex, that.Coords.p2.ey);
        drawDynamicLine(that.Coords.p3.sx, that.Coords.p3.sy, that.Coords.p3.ex, that.Coords.p3.ey);
        drawDynamicLine(that.Coords.p4.sx, that.Coords.p4.sy, that.Coords.p4.ex, that.Coords.p4.ey);

      },
      drawLineOLD() {
        let c = document.getElementById("linecanvas");
        let ctx = c.getContext("2d");
        let halfWidth = window.innerWidth / 2;
        let halfHeight = window.innerHeight / 2;
        ctx.canvas.width = window.innerWidth;
        ctx.canvas.height = window.innerHeight;
        c.addEventListener('click', addDot);
        let prevX = 0,
          prevY = 0,
          cx = 0,
          cy = 0;

        function addDot(e) {
          let size = 0;
          ctx.fillStyle = '#ff0000';
          ctx.strokeStyle = '#ff0000';

          ctx.beginPath();

          if (e.x && e.y) {
            drawDot(e.x, e.y, size);
          } else {
            drawDot(e.clientX, e.clientY, size);
          }
        }

        function drawDot(x, y, s) {
          if (s !== 5) {
            ctx.arc(x, y, s, 0, 2 * Math.PI);
            ctx.fill();
            ctx.stroke();
            s++;
            requestAnimationFrame(function () {
              drawDot(x, y, s);
            });
          } else {
            if (prevX !== 0 && prevY !== 0) {
              addLine(x, y, prevX, prevY);
            } else {
              prevX = x;
              prevY = y;
            }
          }
        }

        function addLine(x, y, px, py) {
          let goingForward = false,
            goingUp = false;

          ctx.beginPath();
          ctx.moveTo(px, py);
          cx = px;
          cy = py;

          if (cx < x) {
            goingForward = true;
          }

          if (cy > y) {
            goingUp = true;
          }

          drawLine(x, y, goingForward, goingUp);
        }

        function drawLine(x, y, gf, gu) {
          let metX = false,
            metY = false;
          c.removeEventListener('click', addDot);

          ctx.lineTo(cx, cy);
          ctx.stroke();

          if (gf) {
            if (cx >= x) {
              metX = true;
            }

            if (cx < x && !metX) {
              cx += 4;
            }

          } else {
            if (cx <= x) {
              metX = true;
            }

            if (cx > x && !metX) {
              cx -= 4;
            }
          }

          if (gu) {
            if (cy <= y) {
              metY = true;
            }

            if (cy > y && !metY) {
              cy -= 4;
            }

          } else {
            if (cy >= y) {
              metY = true;
            }

            if (cy < y && !metY) {
              cy += 4;
            }
          }

          if (!metY || !metX) {
            requestAnimationFrame(function () {
              drawLine(x, y, gf, gu);
            });
          } else {
            prevX = x;
            prevY = y;
            c.addEventListener('click', addDot);
          }
        }
      },


    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      //获取场景点位
      //var startObj = document.getElementById("f1");
      var that = this;
      var coords = this.Coords;
      $(".list .item").find("img").on('load', function () {
        for (let key in coords) {
          let curdot = coords[key];
          let startid = "#" + key;
          curdot.sy = $(startid).offset().top;
          curdot.sx = $(startid).offset().left;
          curdot.ex = $(curdot.startId).offset().left + $(curdot.startId).width();
          curdot.ey = $(curdot.startId).offset().top + $(curdot.startId).height() / 2;
          //起点元素中心坐标         
        }
        //that.animationline();
      })


    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  .scenelist {
    /* position:relative;
    width: 100%;
    height: 100%;
    background: url(../../assets/images/f1/bg.jpg)center 100%;
    background-size: 100% 100%; */
    overflow: hidden;

    /* &:before {
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.8);
    } */

    .drawing-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 1920px;
      height: 1000px;

      #linecanvas {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }


    .inner {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      .top-model {
        height:80%;
        .f1 {
          padding-top: 6vw;

          .model {
            position: relative;
            /* width: 50.7vw;
            height: 33.8vw; */
            width: 56.4vw;
            margin: 0 auto;

            span {
              display: block;
              display:none;
              width: 10px;
              height: 10px;
              background: #ff0000;
              position: absolute;

              &.item1 {
                top: 7vw;
                left: 10vw;
              }

              &.item2 {
                top: 18vw;
                left: 9vw;
              }

              &.item3 {
                top: 8vw;
                left: 22vw;
              }

              &.item4 {
                top: 9vw;
                left: 37vw;
              }
            }
          }

          .list {
            .item {
              cursor:pointer;
              position: absolute;
              width: 9.3vw;
              border-radius:0.5vw 0.5vw 0 0 ;
              .gif {
                border-radius:0.5vw 0.5vw 0 0;
              }
              .intro {
                background:#e60012;
                color:#fff;
                padding:0.5vw 0;
                border-radius: 0 0 0.5vw 0.5vw;
                span {
                  font-size: 1.1vw;
                }
                p {
                  font-size:0.8vw;
                }
              }

              &.item1 {
                top: 11.3vw;
                left: 13vw;
              }

              &.item2 {
                top: 22.1vw;
                left: 13vw;
              }

              &.item3 {
                top: 4vw;
                right: 22vw;
              }

              &.item4 {
                top: 14vw;
                right: 12.5vw;
              }
            }
          }

          .line {
            img {
              position: absolute;
            }

          }
        }

        .f2 {
          padding-top: 6vw;

          .model {
            width: 54.9vw;
            margin: 0 auto;
          }

          .list {
            .item {
              cursor:pointer;
              position: absolute;
              width: 9.3vw;
              border-radius:0.5vw 0.5vw 0 0 ;
              .gif {
                border-radius:0.5vw 0.5vw 0 0;
              }
              .intro {
                background:#e60012;
                color:#fff;
                padding:0.5vw 0;
                border-radius: 0 0 0.5vw 0.5vw;
                span {
                  font-size: 1.1vw;
                }
                p {
                  font-size:0.7vw;
                }
              }

              &.item5 {
                top: 12vw;
                left: 13.5vw;
              }

              &.item6 {
                top: 24vw;
                left: 13.5vw;
              }

              &.item7 {
                top: 10vw;
                right: 18.8vw;
              }

              &.item8 {
                top: 30vw;
                right: 20.5vw;
              }
              
            }
          }
        }
      }

      .bottom-nav {
        margin-top: 6vh;

        span {
          display: inline-block;
          width: 2.6vw;
          height: 2.6vw;
          border: 2px solid #e60012;
          font-size: 1.1vw;
          font-weight: bold;
          color: #e60012;
          line-height: calc(2.6vw - 4px);
          text-align: center;
          margin: 0 1vw;
          cursor:pointer;

          &.on {
            background: #e60012;
            color: #fff;
          }
        }
      }
    }
    .minner {
      position:relative;
      width:100%;
      height:100%;
      overflow: scroll;
      &:before {
        content:'';
        display:block;
        position:absolute;
        top:0;
        width:100%;
        height:60vw;
        background:url(../../assets/images/mobile/top.png)top center/100% no-repeat;
      }
      .mcontainer {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        z-index:2;
        .title {
          width:73.7vw;
          color:#fff;
          font-size:8vw;
          font-weight: bold;
          background:url(../../assets/images/mobile/title-line.png)bottom center /100% no-repeat;
          margin:8vw auto 7.3vw;
          padding-bottom:1.3vw;
        }
        .list {
          display:flex;
          flex-wrap:wrap;
          padding:0 5.3vw;
          justify-content: space-between;
          .item {
            width:42.8vw;
            color:#fff;
            border-radius:1.6vw;
            background:#e60012;
            margin-bottom:6.6vw;
            img {
              border-radius:1.6vw 1.6vw 0 0;
              margin-bottom:3.3vw;
            }
            .name {
              font-size:4vw;
              font-weight: bold;
              
            }
            .intro {
              font-size:3.2vw;
              padding-bottom:3.3vw;
              padding-top:2vw;
            }
          }
        }
        .goback {
          width:28vw;
          margin:6.67vw auto;
        }
      }
      
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/scenes/index.vue